import {
  DIALOG_OPEN,
  DIALOG_SUBMIT,
  DIALOG_CANCEL
} from 'actions/dialog'

export const initialState = []

const dialog = (state = initialState, action) => {
  switch (action.type) {
    case DIALOG_OPEN: {
      return [
        ...state,
        {
          id: action.id,
          message: action.message,
          submitMessage: action.submitMessage,
          cancelMessage: action.cancelMessage,
          title: action.title
        }
      ]
    }
    case DIALOG_CANCEL:
    case DIALOG_SUBMIT: {
      return state.filter(e => e.id !== action.id)
    }
  }
  return state
}

export default dialog
